import { fileUploadColumn, grandTotalFields, totalsColumn, unitInputColumn, valueInputColumn } from './columns'

// --- Waste to Landfill Columns---
export const wasteToLandfillColumns = [
    {
        label: 'Waste',
        field: 'type',
        type: 'select',
        options: [
            { id: 0, value: 'General Mixed Waste' }
        ],
        selectLabel: 'Type'
    },
    {
        ...unitInputColumn,
        options: [
            { id: 0, value: 'Kilograms' }
        ],
    },
    valueInputColumn,
    fileUploadColumn,
]

// --- Waste to Landfill Totals ---

export const wasteToLandfillTotalColumns = totalsColumn.kilograms
export const wasteToLandfillGrandTotalFields = grandTotalFields.kilograms

// --- Waste to Recycling Columns ---

export const wasteToRecyclingColumns = [
    {
        label: 'Waste',
        field: 'type',
        type: 'select',
        options: [
            { id: 0, value: 'Paper/cardboard' },
            { id: 1, value: 'Plastics' },
            { id: 2, value: 'Glass' },
            { id: 3, value: 'Mixed Recyclables' },
        ],
        selectLabel: 'Recycling Type'
    },
    {
        ...unitInputColumn,
        options: [
            { id: 0, value: 'Kilograms' },
        ],
    },
    valueInputColumn,
    fileUploadColumn,
]

// --- Waste to Recycling Totals ---

export const wasteToRecyclingTotalColumns = totalsColumn.kilograms
export const wasteToRecyclingGrandTotalFields = grandTotalFields.kilograms

// --- Waste to Composting Columns ---

export const wasteToCompostingColumns = [
    {
        label: 'Waste',
        field: 'type',
        type: 'select',
        options: [
            { id: 0, value: 'Woody Biomass' },
            { id: 1, value: 'Winery Waste' },
            { id: 2, value: 'Mixed Organics' },
        ],
        selectLabel: 'Waste Type'
    },
    {
        label: 'Treatment Location',
        field: 'treatmentLocation',
        type: 'select',
        options: [
            { id: 0, value: 'On-Site Composting' },
            { id: 1, value: 'Off-Site Composting' },
        ],
        selectLabel: 'Select Location'
    },
    {
        ...unitInputColumn,
        options: [
            { id: 0, value: 'Kilograms' },
        ],
    },
    valueInputColumn,
    fileUploadColumn,
]

// --- Waste to Composting Totals ---

export const wasteToCompostingTotalColumns = totalsColumn.kilograms
export const wasteToCompostingGrandTotalFields = grandTotalFields.kilograms

// --- Wastewater Treatment Columns ---

export const wastewaterTreatmentColumns = [
    {
        label: 'Waste',
        field: 'type',
        type: 'select',
        options: [
            { id: 0, value: 'Aerobic treatment plant - Well managed' },
            { id: 1, value: 'Aerobic treatment plant - Overloaded' },
            { id: 2, value: 'Sludge anaerobic digestion' },
            { id: 3, value: 'Anaerobic reactor' },
            { id: 4, value: 'Anaerobic lagoon - depth < 2m' },
            { id: 5, value: 'Anaerobic lagoon - depth > 2m' },
            { id: 6, value: 'None' },
        ],
        selectLabel: 'Treatment Type'
    },
    {
        ...unitInputColumn,
        options: [
            { id: 0, value: 'Kilolitres' },
        ],
    },
    valueInputColumn,
    fileUploadColumn,
]

// --- Wastewater Treatment Totals ---

export const wastewaterTreatmentTotalColumns = totalsColumn.kilolitres
export const wastewaterTreatmentGrandTotalFields = grandTotalFields.kilolitres

// --- Waste to Biochar Production Columns ---

export const wasteToBiocharProductionColumns = [
    {
        label: 'Waste',
        field: 'type',
        type: 'select',
        options: [
            { id: 0, value: 'Flame Cap Kiln (Woody Biomass)' },
        ],
        selectLabel: 'Type'
    },
    {
        ...unitInputColumn,
        options: [
            { id: 0, value: 'Kilograms' },
        ],
    },
    valueInputColumn,
    fileUploadColumn,
]

// --- Waste to Biochar Production Totals ---

export const wasteToBiocharProductionTotalColumns = totalsColumn.kilograms
export const wasteToBiocharProductionGrandTotalFields = grandTotalFields.kilograms
